export default "__VITE_ASSET__Coxg3Qtu__"